var path = '/fund/main/fundDashboardTitle/fundDashboardTitle.tpl.html';
var html = "<div> <h1> <span>{{fundDashboardTitleCtrl.label}}</span> </h1> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/fund/main/fundDashboardTitle/fundDashboardTitle.tpl.html
// module id = 744
// module chunks = 0 2